// extracted by mini-css-extract-plugin
module.exports = {"stepsNav":"DashboardForm_stepsNav__3uXdv","navLink":"DashboardForm_navLink__2CxC9","active":"DashboardForm_active__inpCs"};